export default __webpack_public_path__ + "be7c4a865d127a2cc7ae59da3e8594d1.svg";